import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getAccountApiRecordLogAsync, resetSelectedRecordObjectInState,updatePagination, updateSearchPagination,updateSorting, setPageSize,setSearchValue } from "./ApiRecordLogSlice";
import ApiRecordLogItem from "./ApiRecordLogItem";
import CustomPagination from "../../../common/Pagination";
import { ViewDetails } from "./ViewDetails";
import { useLocation, useNavigate } from 'react-router-dom';
import OffCanvas from '../../../common/OffCanvas';
import Select, { StylesConfig } from 'react-select';
import { useTranslation } from "react-i18next";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useDebounce } from "../../../_metronic/helpers";
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';
import { getValueFromResource } from "../../../common/timeLiveFunction";
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const ApiRecordLog = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { apiRecordLogList, isReload, pageSize, totalItems, search, pageNo, startRec, sortOrder, sortColumn, recordsFiltered, isSearch, isLoading } = useAppSelector((state) => state.apiRecordLog);
    const totalPages = Math.ceil(totalItems / pageSize);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const webhookreceiverlogid = params.get('webhookreceiverlogid');
    const { pageId, menuList, IsList} = useAppSelector((state) => state.globalState);
    

   
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];
    const generalObject = {
        "name":
        //  t("Details"),
        getValueFromResource('Details',dispatch, t),
        "width": "800px",
        "componentName": <ViewDetails t={t} />
    }
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);


    

    useEffect(() => {
        if (webhookreceiverlogid !== null) {
            if (isGuid(webhookreceiverlogid)) {
                dispatch(getAccountApiRecordLogAsync({webhookreceiverlogid}));
            }
            else {
                dispatch(getAccountApiRecordLogAsync({}));
            }
        }
        else {
            dispatch(getAccountApiRecordLogAsync({}));
        }

    }, [dispatch, webhookreceiverlogid])

    const debouncedSearchTerm = useDebounce(search, 500);
 


    useEffect(() => {
        if (isSearch && debouncedSearchTerm !== ' ') {
            if (webhookreceiverlogid === null || webhookreceiverlogid === "") {
                dispatch(getAccountApiRecordLogAsync({}));
            }
            if (webhookreceiverlogid !== null && webhookreceiverlogid !== "") {
                dispatch(getAccountApiRecordLogAsync({webhookreceiverlogid}));
            }               
        }

    }, [debouncedSearchTerm]);
    
    useEffect(() => {
        if (webhookreceiverlogid === null || webhookreceiverlogid === "") {
            dispatch(getAccountApiRecordLogAsync({}));
        }

    },  [pageNo, pageSize, sortOrder, sortColumn]);
    
    const onHandleSearch = (event: any) => {
        dispatch(updateSearchPagination(event.target.value));
    }

    const onHandlePageChange = (pageNumber: any) => {
        let objects = {
            "startRec": (pageNumber - 1) * Number(pageSize),
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const onHandlePageSizeChange = (selectedOption: any) => {
        let objects = {
            "startRec": 0,
            "pageSize": selectedOption.value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const isGuid = (stringToTest: any) => {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        var x = regexGuid.test(stringToTest);
        return x;
    };

    return (
        <>
                 {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Api Record Log')} */}
                        {getValueFromResource('Api Record Log',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                             <input
                                type="text"
                                value={search}
                                onChange={(e: any) => onHandleSearch(e)}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                             <PageSizeSelect onChange={onHandlePageSizeChange} />

                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(apiRecordLogList.length > 0) ? (
                                <CustomPagination
                                currentPage={pageNo}
                                onPageChange={onHandlePageChange}
                                pageSize={pageSize}
                                totalItems={totalItems}
                                start={startRec}
                                t={t}
                                recordsFiltered={recordsFiltered}
                            >
                            </CustomPagination>
                            ) : null}
                        </div>
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <ApiRecordLogItem webhookreceiverlogid={webhookreceiverlogid} t={t} />
                        </div>
                    </div>
                }
            </div>
            <OffCanvas obj={generalObject} />
        </>
    )
}

export default ApiRecordLog;